const api = {
  GHlist: "/api/index.php?api=list",
  GHdocinfo: "/api/index.php?api=docinfo",
  GHscrolltxt: "/api/index.php?api=scrolltxt",
  GHemail: "/api/phpmailer/index.php",
  GHyyjj: "/api/index.php?api=yyjj",
  GHyyhd: "/api/index.php?api=yyhd",
 
};
export default api;
